<ion-header
  no-shadow
  [ngClass]="{
    'colored-bg':
      componentView === 'VIEW_UPLOAD' &&
      !typeContainsDocuments(activeDocumentType)
  }"
>
  <ion-toolbar
    no-border
    [ngClass]="{
      'colored-bg':
        componentView === 'VIEW_UPLOAD' &&
        !typeContainsDocuments(activeDocumentType)
    }"
  >
    <ion-buttons slot="start" class="back-button-section">
      <ion-back-button
        onclick="event.stopImmediatePropagation();"
        (mouseup)="switchView($event)"
        defaultHref=""
        color="dark"
      ></ion-back-button>
    </ion-buttons>

    <ion-title text-left *ngIf="componentView === 'LIST'" no-padding-start>
      <div class="modal-title-text">
        <ion-icon
          [src]="'assets/rcyl-orders/upload-document.svg'"
          color="primary"
        ></ion-icon
        >&nbsp;
        <ion-text font-bold="" color="dark">Order Documents</ion-text>
      </div>
    </ion-title>
    <ion-title
      text-left
      *ngIf="componentView === 'VIEW_UPLOAD'"
      no-padding-start
    >
      <div class="modal-title-text">
        <ion-icon
          [src]="orderDocumentsMap[activeDocumentType]?.icon"
          color="primary"
        ></ion-icon
        >&nbsp;
        <ion-text font-bold="" color="dark">{{
          orderDocumentsMap[activeDocumentType]?.displayText
        }}</ion-text>
      </div>
    </ion-title>
    <ion-buttons slot="end" class="close-button-section">
      <ion-button (click)="closeModal()">
        <ion-icon
          color="medium"
          slot="icon-only"
          name="close-circle"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content
  class="ion-padding"
  [ngClass]="{
    'colored-bg':
      componentView === 'VIEW_UPLOAD' &&
      !typeContainsDocuments(activeDocumentType)
  }"
>
  <ion-list *ngIf="componentView === 'LIST'" padding class="list-view">
    <ion-item
      lines="none"
      *ngFor="
        let orderTypeData of orderDocumentsMap
          | rcylFilter: 'showInList':true
          | rcylKeys
          | orderBy: ['val.documents.length']:'asc'
      "
      (click)="selectDocumentType(orderTypeData?.key)"
    >
      <ion-icon
        [src]="
          typeContainsDocuments(orderTypeData?.key)
            ? orderTypeData?.val?.iconChecked
            : orderTypeData?.val?.icon
        "
        slot="start"
      >
      </ion-icon>
      <ion-label text-wrap>
        <ion-text color="dark" font-bold="">
          {{ orderTypeData?.val?.displayText }}
        </ion-text>
        <br />
        <ion-text
          font-regular=""
          *ngIf="!typeContainsDocuments(orderTypeData?.key)"
        >
          {{ orderTypeData?.val?.beforeUploadText }}
        </ion-text>
        <ion-text
          *ngIf="typeContainsDocuments(orderTypeData?.key)"
          font-regular=""
        >
          {{ orderTypeData?.val?.afterUploadText }}
        </ion-text>
      </ion-label>
      <ion-icon
        [src]="'assets/rcyl-orders/right-arrow.svg'"
        slot="end"
      ></ion-icon>
    </ion-item>
  </ion-list>
  <input
    #fileInputElement
    hidden="true"
    accept="image/*,.pdf,.doc,.txt"
    type="file"
    (change)="handleBrowserFileUploads($event?.target?.files)"
  />
  <ion-grid *ngIf="componentView === 'VIEW_UPLOAD'" class="view-upload">
    <!--<ion-row *ngIf="!typeContainsDocuments(activeDocumentType)">
            <ion-col size="12" no-padding>
                <rcyl-document-sample-for-upload [orderDocumentType]="activeDocumentType"
                                                 [orderDetails]="orderDetails"
                                                 (uploadClick)="handleUploadClick($event)"></rcyl-document-sample-for-upload>
            </ion-col>
        </ion-row>-->
    <ion-row
      text-center
      class="no-upload-img"
      *ngIf="!typeContainsDocuments(activeDocumentType)"
    >
      <div margin padding>
        <ion-icon name="document" mode="ios" color="medium"></ion-icon>
        <!--<ion-img src="assets/rcyl-orders/upload-document.svg"></ion-img>-->
      </div>
    </ion-row>
    <ion-row class="document-list" no-padding>
      <ion-col size="12" no-padding>
        <ion-list lines="none">
          <ion-item-sliding
            class="proforma-invoice-item"
            *ngIf="
              activeDocumentType === orderDocumentTypes.INVOICE &&
              containsInStatusLog(orderStatuses.ORDER_COMPLETED) &&
              orderDetails?.channelType !== 'Marketplace' &&
              orderDetails?.orderType !== 'DROP'
            "
          >
            <ion-item (click)="openProformaInvoice()" margin-bottom>
              <ion-icon slot="start" name="custom-files" mode="md"></ion-icon>
              <ion-label text-wrap>
                Proforma Invoice
                <p>Refer this document to prepare the final invoice.</p>
              </ion-label>
            </ion-item>
          </ion-item-sliding>

          <ion-item-sliding
            *ngFor="let doc of orderDocumentsMap[activeDocumentType].documents"
          >
            <ion-item (click)="openViewFile(doc)">
              <ion-img
                slot="start"
                *ngIf="doc?.contentType?.includes('image')"
                [src]="doc?.url"
              ></ion-img>
              <ion-icon
                slot="start"
                *ngIf="!doc?.contentType?.includes('image')"
                name="custom-files"
                mode="md"
              ></ion-icon>
              <ion-label text-wrap>
                {{ doc.fileName }}
                <p *ngIf="doc?.fileSize">
                  Size {{ doc.fileSize / 1024 | number: "1.2-2" }} KB
                </p>
              </ion-label>
              <ion-button
                *ngIf="canUploadDelete()"
                (click)="deleteImg(doc, $event)"
                fill="clear"
                slot="end"
              >
                <ion-icon
                  name="trash"
                  slot="icon-only"
                  color="medium"
                ></ion-icon>
              </ion-button>
            </ion-item>
            <ion-item-options side="end" *ngIf="canUploadDelete()">
              <ion-item-option color="danger" (click)="deleteImg(doc, $event)"
                >Delete</ion-item-option
              >
            </ion-item-options>
          </ion-item-sliding>
        </ion-list>
        <ion-row>
          <!--<ion-col size="12"
                             *ngFor="let doc of orderDocumentsMap[activeDocumentType].documents">
                        <ion-row>
                            <ion-col size="4">
                                <ion-img *ngIf="doc?.contentType?.includes('image')" [src]="doc?.url"></ion-img>
                            </ion-col>
                            <ion-col size="8">

                            </ion-col>
                        </ion-row>
                        <div class="img-container" (click)="openViewFile(doc)">
                            <ion-button *ngIf="canUploadDelete()" (click)="deleteImg(doc, $event)" size="small" fill="clear" no-box-shadow>
                                <ion-icon size="small" color="medium" name="close-circle"></ion-icon>
                            </ion-button>
                            <ion-img *ngIf="doc?.contentType?.includes('image')" [src]="doc?.url"></ion-img>
                            <ion-icon *ngIf="!doc?.contentType?.includes('image')" name="custom-files" mode="md"></ion-icon>
                            <p *ngIf="!doc?.contentType?.includes('image')">{{doc.fileName}}</p>
                        </div>
                    </ion-col>-->
          <!--<ion-col size="6" *ngIf="activeDocumentType === orderDocumentTypes.INVOICE && containsInStatusLog(orderStatuses.ORDER_COMPLETED)" >
                        <div class="img-container" (click)="openProformaInvoice()">
                            <ion-icon name="custom-files" mode="md"></ion-icon>
                            <p>Proforma Invoice</p>
                        </div>
                    </ion-col>-->
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer
  no-border
  *ngIf="componentView === 'VIEW_UPLOAD'"
  [ngClass]="{
    'colored-bg':
      componentView === 'VIEW_UPLOAD' &&
      !typeContainsDocuments(activeDocumentType)
  }"
>
  <ion-row>
    <ion-col size="12" text-center>
      <!--<ion-text color="medium" class="note-text">
                <span font-bold>Note: </span>You can upload maximum {{uploadMaxLimit}} documents.
            </ion-text>
            <br/>-->
      <ion-button
        centered=""
        expand="block"
        recykal-button=""
        margin-top
        size="large"
        [disabled]="!canUploadDelete()"
        (click)="handleUploadClick(activeDocumentType)"
      >
        <ion-icon name="cloud-upload"></ion-icon> &nbsp; Upload Document
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
